import { Link } from "react-router-dom";
import { trackPlayStoreClick, trackAppStoreClick, BADGE_LOCATIONS } from "@/lib/analytics";

// Store badges
import appStoreBadge from "@/assets/images/Download_on_the_App_Store_Badge_US-UK_RGB_blk_092917.svg";
import playStoreBadge from "@/assets/images/GetItOnGooglePlay_Badge_Web_color_English.svg";

export function SiteFooter() {
  return (
    <div className="border-t border-[--border-primary]">
      <div className="max-w-[1470px] mx-auto px-4 md:px-8 py-8 text-center text-sm text-[--text-muted]">
        {/* Store Badges */}
        <div className="flex items-center justify-center gap-3 mb-6">
          <a 
            href="https://play.google.com/store/apps/details?id=com.anotherwhy.zero" 
            target="_blank" 
            rel="noopener noreferrer"
            className="hover:opacity-80 transition-opacity"
            aria-label="Get it on Google Play"
            onClick={() => trackPlayStoreClick(BADGE_LOCATIONS.FOOTER)}
          >
            <img 
              src={playStoreBadge} 
              alt="Get it on Google Play" 
              className="h-10"
            />
          </a>
          <a 
            href="https://apps.apple.com/us/app/zero-offline-expense-tracker/id6759560225" 
            target="_blank" 
            rel="noopener noreferrer"
            className="hover:opacity-80 transition-opacity"
            aria-label="Download on the App Store"
            onClick={() => trackAppStoreClick(BADGE_LOCATIONS.FOOTER)}
          >
            <img 
              src={appStoreBadge} 
              alt="Download on the App Store" 
              className="h-10"
            />
          </a>
        </div>

        {/* Links */}
        <div className="flex items-center justify-center gap-4 mb-3">
          <Link
            to="/privacy-policy"
            className="hover:text-[--text-primary] transition-colors"
          >
            Privacy
          </Link>
          <span className="text-[--border-primary]">·</span>
          <Link
            to="/terms"
            className="hover:text-[--text-primary] transition-colors"
          >
            Terms
          </Link>
        </div>
        <p className="mb-2">© 2026 anotherwhy technologies</p>
        <p className="text-xs">
          Registration: UDYAM-WB-23-0072504
        </p>
      </div>
    </div>
  );
}
